export class ClientTacker {
  private logger: any | undefined = void 0;

  set(logger: any) {
    this.logger = logger;
  }

  get() {
    return this?.logger ? this.logger : console;
  }
}
